import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/admin/badges', {
      params,
    })
    return response
  },
  async update(payload) {
    let response = await api.put('/admin/badges', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/badges', {
      data: payload,
    })
    return response
  },
  async create(payload) {
    const response = await api.post('/admin/badges', payload)
    return response
  },
  async get(params) {
    let response = await api.get('/admin/badges/detail', {
      params,
    })
    return response.data.data.document || null
  },
}
